<template>
  <div
    class="py-2 px-5 rounded-full bg-gray-100 border border-gray-200 flex flex-col justify-center text-center text-sm"
  >
    <span v-text="$store.state.support.i18n.time_in_paris"></span>
    <div v-text="timeNow" class="font-bold text-base"></div>
    <div v-text="dateNow"></div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ["i18n"],
  components: {},
  mixins: [],
  data: function () {
    return {
      dateNow: undefined,
      timeNow: undefined,
    };
  },
  methods: {
    getDate() {
      return moment().locale(this.locale).format("dddd LL");
    },
    getTime() {
      return moment().locale(this.locale).format("LTS");
    },
    time() {
      var self = this;
      this.dateNow = this.getDate();
      this.timeNow = this.getTime();

      setTimeout(self.time, 1000);
    },
  },
  computed: {
    locale() {
      return this.$route.params.locale;
    },
  },
  mounted() {
    this.time();
  },
};
</script>

<style></style>
